module.exports = __webpack_public_path__ + "img/offers.daily.ec399766.png";